import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Flame, Home, PlusCircle, User, Shield, Trophy, Share2, Dog, FileText, ShoppingBag, Users } from 'lucide-react';
import { NotificationBell } from './NotificationBell';

export function Navbar() {
  const { user, logout, isAdmin } = useAuth();

  return (
    <nav className="sticky top-0 z-50 bg-black/90 backdrop-blur-lg border-b border-white/10" data-testid="navbar">
      <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <Flame className="w-7 h-7 text-primary group-hover:scale-110 transition-transform" strokeWidth={2.5} />
          <span className="font-heading font-extrabold text-xl tracking-tight text-white hidden sm:block">
            ZNAJDOWNIK
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm text-muted-foreground hover:text-white transition-colors" data-testid="nav-feed">Gadulec</Link>
          <Link to="/produkty" className="text-sm text-muted-foreground hover:text-white transition-colors" data-testid="nav-products">Produkty</Link>
          <Link to="/blog" className="text-sm text-muted-foreground hover:text-white transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/groups" className="text-sm text-muted-foreground hover:text-white transition-colors" data-testid="nav-groups">Grupy</Link>
          {user && (
            <>
              <Link to="/wachalski" className="text-sm text-primary hover:text-primary/80 font-bold transition-colors flex items-center gap-1" data-testid="nav-wachalski">
                <Dog className="w-4 h-4" /> Wąchalski
              </Link>
              <Link to="/submit" className="text-sm text-muted-foreground hover:text-white font-medium transition-colors" data-testid="nav-submit">
                + Dodaj okazję
              </Link>
              <Link to="/referral" className="text-sm text-zorki hover:text-zorki/80 font-bold transition-colors flex items-center gap-1" data-testid="nav-referral">
                <Share2 className="w-3.5 h-3.5" /> Polecaj
              </Link>
            </>
          )}
        </div>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/shop" className="flex items-center gap-1.5 text-sm group" data-testid="nav-zorki">
                <span className="text-zorki font-heading font-bold group-hover:underline">{user.zorki || 0}</span>
                <span className="text-xs text-muted-foreground">Zorków</span>
              </Link>
              <NotificationBell />
              {isAdmin && (
                <Link to="/admin" className="text-xs text-primary/80 hover:text-primary" data-testid="nav-admin">
                  <Shield className="w-4 h-4" />
                </Link>
              )}
              <Link to="/profile" className="text-sm text-muted-foreground hover:text-white" data-testid="nav-profile">
                <User className="w-5 h-5" />
              </Link>
              <button
                onClick={logout}
                className="text-xs text-muted-foreground hover:text-white transition-colors"
                data-testid="nav-logout"
              >
                Wyloguj
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              className="bg-primary text-primary-foreground px-4 py-1.5 font-heading font-bold uppercase text-sm tracking-wider hover:bg-primary/90 transition-colors"
              data-testid="nav-login-btn"
            >
              Zaloguj
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export function BottomNav() {
  const { user, isAdmin } = useAuth();
  const location = useLocation();
  const path = location.pathname;

  const items = [
    { to: '/', icon: Home, label: 'Gadulec', active: path === '/' },
    ...(user ? [{ to: '/wachalski', icon: Dog, label: 'Szukaj', active: path === '/wachalski', primary: true }] : []),
    ...(user ? [{ to: '/shop', icon: ShoppingBag, label: 'Sklep', active: path === '/shop' }] : []),
    ...(user
      ? [{ to: '/profile', icon: User, label: 'Profil', active: path === '/profile' }]
      : [{ to: '/auth', icon: User, label: 'Zaloguj', active: path === '/auth' }]
    ),
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-lg border-t border-white/10 flex justify-around p-2 z-50 md:hidden" data-testid="bottom-nav">
      {items.map(({ to, icon: Icon, label, active, primary }) => (
        <Link
          key={to}
          to={to}
          className={`flex flex-col items-center gap-0.5 px-3 py-1 transition-colors ${
            primary
              ? 'text-primary'
              : active
                ? 'text-white'
                : 'text-muted-foreground'
          }`}
          data-testid={`bottom-nav-${label.toLowerCase()}`}
        >
          <Icon className={`w-5 h-5 ${primary ? 'stroke-[2.5]' : ''}`} />
          <span className="text-[10px] font-heading uppercase tracking-wider">{label}</span>
        </Link>
      ))}
    </div>
  );
}
